import { render, staticRenderFns } from "./CoreHeader.vue?vue&type=template&id=8e6622b0"
import script from "./CoreHeader.vue?vue&type=script&lang=js"
export * from "./CoreHeader.vue?vue&type=script&lang=js"
import style0 from "./CoreHeader.vue?vue&type=style&index=0&id=8e6622b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports